import type { Dispatch, SetStateAction, ReactElement, ReactNode } from "react";
import IconButton from "./IconButton";
import ContextMenu from "./ContextMenu";

type ContextMenuProps = {
  clickEvent?: React.MouseEvent;
  children: ReactNode;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  title?: string | ReactElement;
  position?: "cursor" | "below" | "bottomRight";
  anchor?: React.RefObject<HTMLElement>;
};

export default function ContextMenuModal({
  title,
  children,
  ...rest
}: ContextMenuProps) {
  return (
    <ContextMenu {...rest}>
      <div className="max-h-[100vh] w-screen max-w-[100vw] space-y-3 overflow-y-auto rounded-md border-slate-200 border bg-white p-8 shadow-xl md:w-96">
        <ContextMenuHeader title={title} onCancel={() => rest.setShow(false)} />
        {children}
      </div>
    </ContextMenu>
  );
}

type ContextMenuHeaderProps = {
  title?: string | ReactElement;
  onCancel: () => void;
};

function ContextMenuHeader({ title, onCancel }: ContextMenuHeaderProps) {
  return (
    <div className="top-0 z-20 flex flex-row items-center justify-end gap-3 bg-white">
      {title && <div className="py-2 text-lg">{title}</div>}
      <div className="ml-auto">
        <IconButton
          aria-label="Stäng"
          icon="xmark"
          onClick={(ev) => {
            ev.stopPropagation();
            ev.nativeEvent.stopImmediatePropagation();
            onCancel();
          }}
        />
      </div>
    </div>
  );
}
